import axios from 'axios'

import { AuthResponse } from '../redux/authSlice/authSlice'

// auth api instance
const authInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
})

// data api instance
const dataInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
})

// auth api response interceptor
authInstance.interceptors.response.use(function (response) {
  const token = response.data.accessToken
  console.log(response.data.accessToken)
  if (token !== null && token !== undefined) localStorage.setItem('user', JSON.stringify([response.data]))
  return response
}, async function (error) {
  return await Promise.reject(error)
})

// data api's request interceptor
dataInstance.interceptors.request.use(function (config) {
  const stringifyData = localStorage.getItem('user')
  let jsonData: AuthResponse[]
  if (stringifyData !== null && stringifyData !== undefined) {
    jsonData = JSON.parse(stringifyData)
    // config.headers.Authorization = `Bearer ${jsonData[0].token}`
    config.headers['x-access-token'] = jsonData[0].accessToken
  }
 if (!(config.data instanceof FormData)) {
  config.headers['Content-Type'] = 'application/json';
}
  return config
}, async function (error) {
  return await Promise.reject(error)
})


// data api response interceptor
dataInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {

    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data?.message ===
        "Your account has been deleted by the administrator as per your request."
    ) {
      // Clear login details
      localStorage.removeItem("user");

     // Clear login details
localStorage.removeItem("user");

// Store the message
localStorage.setItem(
  "logoutMessage",
  error.response.data.message
);

// Redirect to Login
window.location.href = "/Login";
    }

    return await Promise.reject(error);
  }
);


export { authInstance, dataInstance }
